import { useState, useEffect, memo, useRef } from 'react';
import CustomDateRangePicker from '../../../Dispatch/DispatchChat/MessageHistory/components/CustomDateRangePicker';
import appConstants from '../../../../../appConstants';
import constants from '../../../Dispatch/DispatchChat/MessageHistory/constants';
import { format } from 'date-fns';
import { withStyles } from '@material-ui/core';
const DEFAULT_DATE_RANGE = [
  {
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection'
  }
];
const styles = () => ({
  container: {
    marginLeft: 8
  }
});

const DateRange = (props) => {
  const [selectedDateRange, setSelectedDateRange] = useState(DEFAULT_DATE_RANGE);
  const isFilterAppliedRef = useRef(false);

  useEffect(() => {
    isFilterAppliedRef.current = props.filter.isApplied;
    if (!props.filter.isApplied) {
      setSelectedDateRange(DEFAULT_DATE_RANGE);
    }
  }, [props.filter.isApplied]);

  const updateDateRange = (dateRange) => {
    setSelectedDateRange(dateRange);
    if (dateRange) {
      const startDate = format(dateRange[0].startDate, appConstants.APP_DATE_FORMAT);
      const endDate = format(dateRange[0].endDate, appConstants.APP_DATE_FORMAT);
      props.onClick({
        predicate: handlePredicate([startDate, endDate]),
        isApplied: true
      });
      isFilterAppliedRef.current = true;
    } else {
      props.onClick({
        predicate: handlePredicate([]),
        isApplied: false
      });
      isFilterAppliedRef.current = false;
    }
  };

  const handlePredicate = ([startDate, endDate]) => {
    const predicate = props.filter.predicate.split(' ');
    predicate[2] = `${startDate}/${endDate}`;
    return predicate.join(' ');
  };

  return (
    <div className={props.classes.container}>
      <CustomDateRangePicker
        selectedDateRange={selectedDateRange}
        onChangeDateRange={updateDateRange}
        fullWidth
        skipMaxDate
        shouldDisplayDateRange={isFilterAppliedRef?.current}
        staticRanges={constants.STATIC_DATE_RANGE_LIST}
      />
    </div>
  );
};

export default withStyles(styles)(memo(DateRange));
